import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import useQuasar from 'quasar/src/composables/use-quasar.js';
import {useEnvStore} from '@/stores/useEnvStore'
import {usePartnerStore} from '@/stores/usePartnerStore'
import {storeToRefs} from 'pinia'
import {computed} from 'vue'
import EnvEditComponent from '@/components/EnvEditComponent.vue'
import NotFoundView from '@/views/NotFoundView.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const $q = useQuasar()
useEnvStore()
const {status} = storeToRefs(usePartnerStore())
const isNotFound = computed(() => status.value === 404)

$q.iconMapFn = (iconName) => {
  if (iconName === 'cancel') {
    return {
      cls: 'app-x',
    }
  }
  if (iconName === 'event') {
    return {
      cls: 'app-calendar',
    }
  }
  if (iconName.startsWith('app-')) {
    return {
      cls: iconName,
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EnvEditComponent),
    (_unref(isNotFound))
      ? (_openBlock(), _createBlock(NotFoundView, { key: 0 }))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
  ], 64))
}
}

})